var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3,
    y1: 32.01,
    x2: 61.01,
    y2: 32.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb415"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 28.42,
    y1: 28.75,
    x2: 35.58,
    y2: 28.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#141c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#090d14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070a0f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 28.46,
    y1: 47.9,
    x2: 35.54,
    y2: 47.9,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14",
    "data-name": "Layer 14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.57,52.77,34.75,8.05a3.19,3.19,0,0,0-5.5,0L3.43,52.77a3.18,3.18,0,0,0,2.75,4.77H57.82A3.2,3.2,0,0,0,60.57,52.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28.42,
    y: 16.02,
    width: 7.16,
    height: 25.47,
    rx: 3.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32,44.32a3.58,3.58,0,0,0,0,7.16A3.58,3.58,0,0,0,32,44.32Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alertIcon.6c9662cb15b2ae0428e0d11bf29f3d38.svg";
export { ForwardRef as ReactComponent };